import { apiInstance } from '../helpers';

export const randomizeServices = {
    create
};

function create(params) {
    return apiInstance.post('/web', params)
        .then(response => {
            return response
        })
        .catch(error => {
            return Promise.reject(error);
        });
}




// WEBPACK FOOTER //
// ./src/services/randomize.services.js